enum Membership {
  CORE = "CORE",
  APEX = "APEX",
}

interface MembershipProduct {
  id: number;
  title: string;
  firstYearPrice: number;
  maxRenewalPrice: number;
}

function toOptionalPositiveInt(value?: string): number | undefined {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return undefined;
  if (parsed <= 0) return undefined;
  return Math.trunc(parsed);
}

export const MEMBERSHIPS: Record<Membership, MembershipProduct> = {
  [Membership.CORE]: {
    id:
      toOptionalPositiveInt(import.meta.env.VITE_MEMBERSHIP_CORE_PRODUCT_ID) ??
      17,
    title: "CORE",
    firstYearPrice: 2500,
    maxRenewalPrice: 500,
  },
  [Membership.APEX]: {
    id:
      toOptionalPositiveInt(import.meta.env.VITE_MEMBERSHIP_APEX_PRODUCT_ID) ??
      18,
    title: "APEX",
    firstYearPrice: 3900,
    maxRenewalPrice: 500,
  },
};

export const MEMBERSHIP_ARRAY = Object.values(MEMBERSHIPS);
